export const URL_API = 'https://highlight-code-api.vercel.app/api';
export const MASUK_NOTIF = 'Berhasil masuk';
export const DAFTAR_NOTIF = 'Berhasil daftar';
export const OPSI_STRINGIFY = {
  skipEmptyString: true,
  skipNull: true,
};
